<template>
  <div class="tabs">
    <ul class="flex text-base">
      <li
        class="relative cursor-pointer xl:hover:text-white mr-8"
        :class="value === index ? 'text-white' : 'text-grey-300'"
        v-for="(tab, index) in tabs"
        :key="index"
        @click="$emit('input', index)"
      >
        <div class="flex flex-col">
          <span class="mb-3 px-1">{{ tab }}</span>
          <i
            :style="{ background: themePrimaryColor }"
            :class="value === index ? 'opacity-100' : 'opacity-0'"
            class="rounded-t w-full h-1"
          ></i>
        </div>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

@Component({})
export default class Tabs extends Vue {
  @Prop() tabs!: string[]
  @Prop() value!: number

  @Getter themePrimaryColor!: string
}
</script>
